var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-editor"},[_c('editor',{attrs:{"init":_vm.editorInit,"tinymce-script-src":"/tinymce/tinymce.min.js"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }